import className from 'classnames/bind';
import Link from 'next/link';
import { FeaturedImage, Heading, PostInfo, RichText } from '@/components';
import styles from './PostsEntry.module.scss';

let cx = className.bind(styles);

export function PostsEntry({ title, content, date, author, uri, featuredImage, excerpt, articleHeadingStyle, imageSizes }) {
  const displayedExcerpt = excerpt && excerpt.replace(' [&hellip;]', '&hellip;');
	return (
		<article className={cx(['ns_posts-entry', 'posts-entry'])}>
			<Link href={uri}>
				<div className={cx(['posts-entry-feature-image-container', !featuredImage && 'no-image'])}>
					{featuredImage ? (
						<FeaturedImage image={featuredImage} className={cx(['ns_posts-entry-feature-image', 'posts-entry-feature-image'])} sizes={imageSizes} />
					) : (
						<svg className={cx(['ns-logo'])} viewBox='0 0 22.5 18' xmlns="http://www.w3.org/2000/svg">
							<g className={cx('ns_logo-icon', 'logo-icon')}>
								<path fillRule="evenodd" clipRule="evenodd" d="M11.1092 4.794C9.6201 3.64269 8.09667 2.52669 6.49463 1.56329C3.62492 -0.163098 0.015625 1.94478 0.015625 5.36453V5.51029V9.04961V9.19537C2.1657 5.88267 6.02078 9.1874 9.09864 11.6255C9.76292 12.1516 10.4327 12.68 11.1092 13.2027C12.5983 14.354 14.1229 15.47 15.7238 16.4334C18.5946 18.1598 22.2039 16.0519 22.2039 12.6322V12.4864V8.94598V8.80022C20.0538 12.1129 16.1988 8.80933 13.1209 6.3712C12.4555 5.84509 11.7868 5.3167 11.1092 4.794Z" />
								<path fillRule="evenodd" clipRule="evenodd" d="M9.33441 13.4915C8.3103 12.6807 7.29615 11.8494 6.21115 11.124C4.6844 10.1025 2.27747 8.50483 0.713074 10.3758C0.192716 10.9976 -0.00435574 11.8483 7.28377e-05 12.6682C0.00450141 13.7307 0.330002 14.7966 0.955538 15.6415C2.30072 17.4613 4.91358 17.9225 6.8068 16.7484C7.52423 16.302 8.94912 15.2316 10.3087 14.2602C10.2578 14.2192 10.2079 14.1782 10.1581 14.1372C9.88355 13.922 9.60676 13.7068 9.33441 13.4915Z" />
								<path fillRule="evenodd" clipRule="evenodd" d="M12.8688 4.5085C13.8929 5.3193 14.9071 6.15061 15.9921 6.87601C17.5188 7.8975 19.9258 9.4952 21.4902 7.62419C22.0105 7.00242 22.2076 6.15175 22.2032 5.33183C22.1987 4.26935 21.8732 3.20346 21.2477 2.35848C19.9025 0.538718 17.2896 0.0775132 15.3964 1.25159C14.679 1.69799 13.2541 2.76844 11.8945 3.73982C11.9455 3.78082 11.9953 3.82181 12.0451 3.86281C12.3197 4.07804 12.5965 4.29327 12.8688 4.5085Z" />
							</g>
						</svg>
					)}
				</div>
			</Link>
			<Link href={uri} className={cx(['posts-entry-title-link'])}>
				<Heading className={cx(['ns_posts-entry-title', 'posts-entry-title', articleHeadingStyle])} level='h3'>
					{title}
				</Heading>
			</Link>
      {excerpt && <RichText className={cx(['posts-entry-excert'])} html={displayedExcerpt} />}
			<PostInfo className={cx(['post-info-listing'])} author={author} />
		</article>
	);
}